import React from 'react'
import { Shield, Zap, Sparkles } from 'lucide-react'

export function DopamineShieldCard({ minutesSaved = 35, bpGenerated = 420 }) {
  return (
    <div className="relative rounded-2xl bg-gradient-to-b from-[#131b2c] to-[#0c121e] border border-slate-700/60 p-4 shadow-xl overflow-hidden">
      {/* Top Header */}
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <Shield size={16} className="text-emerald-400" />
          <h3 className="text-sm font-bold text-white tracking-wide">
            Escudo Anti-Doomscrolling
          </h3>
        </div>
        <span className="px-2 py-0.5 rounded-full bg-emerald-950/70 border border-emerald-500/40 text-emerald-300 text-[10px] font-bold">
          +14% Velocidad
        </span>
      </div>

      {/* Main Stats Block */}
      <div className="flex items-center gap-4 my-2">
        {/* Circular Gauge */}
        <div className="relative w-20 h-20 shrink-0 flex items-center justify-center">
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 72 72">
            <circle
              cx="36"
              cy="36"
              r="30"
              className="stroke-slate-800"
              strokeWidth="5"
              fill="transparent"
            />
            <circle
              cx="36"
              cy="36"
              r="30"
              className="stroke-emerald-400"
              strokeWidth="5"
              strokeDasharray="188.4"
              strokeDashoffset="45"
              strokeLinecap="round"
              fill="transparent"
              style={{ filter: 'drop-shadow(0 0 6px rgba(16,185,129,0.5))' }}
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
            <span className="text-sm font-black text-white leading-none">{minutesSaved}m</span>
            <span className="text-[9px] text-slate-400 uppercase tracking-tighter mt-0.5">salvados</span>
          </div>
        </div>

        {/* Text Info */}
        <div className="flex-1">
          <div className="text-lg font-black text-emerald-400 flex items-baseline gap-1">
            <span>+{bpGenerated} BP</span>
            <span className="text-[10px] font-medium text-slate-400">generados</span>
          </div>
          <p className="text-[11px] text-slate-300 leading-snug mt-1">
            Has esquivado la trampa del feed infinito. Tu mente está sincronizada y afilada.
          </p>
        </div>
      </div>

      {/* Bottom Tags */}
      <div className="flex items-center gap-2 pt-2 border-t border-slate-800/80 text-[11px]">
        <div className="flex items-center gap-1 text-cyan-400 font-semibold">
          <Sparkles size={12} />
          <span>Foco Alto</span>
        </div>
        <span className="text-slate-600">·</span>
        <div className="flex items-center gap-1 text-purple-400 font-semibold">
          <Zap size={12} />
          <span>Reflejos Top 5%</span>
        </div>
      </div>
    </div>
  )
}
